import { useAProgress } from 'hooks/useAProgress'
import { Company } from 'modules/domain/company/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent } from 'views/components/SharedModal'

type Props = {
  onClose: () => void
  branch: Company
  onSuccess: () => void
}

export const RemoveBranchModal: FC<Props> = ({ onClose, branch, onSuccess }) => {
  const { t } = useTranslation(['company'])

  const [progress, remove] = useAProgress(() => apiClient.patch(endpoints.company(branch.id), { parent: null }), {
    eventName: 'removeCompanyLink',
    onSuccess,
  })

  return (
    <ResponsiveModal
      id="removeCompanyParent"
      onClose={onClose}
      title={t('removeCompanyParent')}
      onConfirm={remove}
      confirmButtonText={t('common:yes_remove')}
      progress={progress}
      size="small"
    >
      <SharedModalContent>
        {t('removeCompanyLink')} {branch.name}?
      </SharedModalContent>
    </ResponsiveModal>
  )
}
